import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { CHART_COLOURS } from './ChartColours'
import { formatCategoryLabel, maxLabelLength } from '@/lib/chartLabels'

function ChartTooltip({ active, payload }) {
  if (!active || !payload?.length) return null
  const item = payload[0]?.payload
  if (!item) return null
  return (
    <div className="rounded-lg border border-border bg-card px-3 py-2 text-sm shadow-md">
      <p className="font-medium capitalize text-foreground">{item.label}</p>
      <p className="text-muted-foreground">{item.value?.toLocaleString('en-GB')}</p>
    </div>
  )
}

export function SimpleBarChart({
  data,
  emptyMessage = 'No data',
  formatLabel = formatCategoryLabel,
}) {
  if (!data?.length) {
    return (
      <p className="flex h-[220px] items-center justify-center text-sm text-muted-foreground">
        {emptyMessage}
      </p>
    )
  }

  const chartData = data.map((row) => ({
    ...row,
    displayLabel: formatLabel(row.label),
  }))

  const longest = maxLabelLength(chartData, 'displayLabel')
  const axisWidth = Math.min(160, Math.max(72, longest * 7 + 16))
  const chartHeight = Math.max(180, chartData.length * 44 + 24)

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <BarChart
        data={chartData}
        layout="vertical"
        margin={{ top: 4, right: 16, left: 4, bottom: 4 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" horizontal={false} />
        <XAxis
          type="number"
          stroke="hsl(var(--muted-foreground))"
          tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: 12 }}
          allowDecimals={false}
        />
        <YAxis
          type="category"
          dataKey="displayLabel"
          width={axisWidth}
          stroke="hsl(var(--muted-foreground))"
          tick={{ fill: 'hsl(var(--foreground))', fontSize: 13, fontWeight: 500 }}
          tickLine={false}
        />
        <Tooltip content={<ChartTooltip />} />
        <Bar dataKey="value" fill={CHART_COLOURS[0]} radius={[0, 4, 4, 0]} maxBarSize={28} />
      </BarChart>
    </ResponsiveContainer>
  )
}
